export const FETCH_SHIPMENT_STATUS_PENDING = 'FETCH_SHIPMENT_STATUS_PENDING';
export const FETCH_SHIPMENT_STATUS_FULFILLED = 'FETCH_SHIPMENT_STATUS_FULFILLED';
export const FETCH_SHIPMENT_STATUS_FAILED = 'FETCH_SHIPMENT_STATUS_FAILED';
export const FETCH_EXPRESS_SERVICES_PENDING = 'FETCH_EXPRESS_SERVICES_PENDING';
export const FETCH_EXPRESS_SERVICES_FULFILLED = 'FETCH_EXPRESS_SERVICES_FULFILLED';
export const FETCH_EXPRESS_SERVICES_FAILED = 'FETCH_EXPRESS_SERVICES_FAILED';
